import styled from 'styled-components';
import { Button } from './Button.styled';
import { ConsoleInput } from './input.styled';
import { statusColors, StatusTone } from '../consoleTheme';

export const PageContainer = styled.div`display: flex; flex-direction: column; gap: 16px; min-width: 0;`;
export const TopBar = styled.div`
    display: flex; align-items: center; justify-content: space-between;
    flex-wrap: wrap; gap: 12px; padding: 0 0 16px;
    border-bottom: 1px solid ${({ theme }) => theme.color.primary_300};
`;
export const SearchGroup = styled.div`display: flex; align-items: center; gap: 8px; flex-wrap: wrap; min-width: 0;`;
export const SearchInput = styled(ConsoleInput)`width: 220px; max-width: 100%;`;
export const SearchButton = styled(Button).attrs({ $variant: 'secondary' })``;
export const TotalCount = styled.div`
    color: ${({ theme }) => theme.color.text_color_300}; font-size: 12px;
    span { color: ${({ theme }) => theme.color.text_color_100}; font-weight: 600; font-variant-numeric: tabular-nums; }
`;
export const TableArea = styled.div<{ $minWidth?: number; $stickyActions?: boolean }>`
    width: 100%; min-width: 0; overflow-x: auto;
    border: 1px solid ${({ theme }) => theme.color.primary_300}; border-radius: 8px;
    background: ${({ theme }) => theme.color.primary_100};
    & > table { min-width: ${({ $minWidth }) => $minWidth || 0}px; }
    ${({ $stickyActions, theme }) => $stickyActions && `
        th:last-child, td:last-child:not([colspan]) { position: sticky; right: 0; background: ${theme.color.primary_100}; box-shadow: inset 1px 0 ${theme.color.primary_300}; }
        th:last-child { background: ${theme.color.primary_50}; }
    `}
`;
export const Table = styled.table`
    width: 100%; border-collapse: collapse; text-align: left; table-layout: fixed;
    font-variant-numeric: tabular-nums;
`;
export const Th = styled.th<{ $width?: string }>`
    height: 36px; padding: 8px 12px; border-bottom: 1px solid ${({ theme }) => theme.color.primary_300};
    background: ${({ theme }) => theme.color.primary_50}; color: ${({ theme }) => theme.color.text_color_300};
    font-size: 12px; font-weight: 500; white-space: nowrap;
    ${({ $width }) => $width && `width: ${$width};`}
`;
export const Td = styled.td`
    height: 44px; padding: 10px 12px; border-bottom: 1px solid ${({ theme }) => theme.color.primary_300};
    color: ${({ theme }) => theme.color.text_color_100}; font-size: 13px; line-height: 20px;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
`;
export const Tr = styled.tr<{ $clickable?: boolean }>`
    ${({ $clickable }) => $clickable && 'cursor: pointer;'}
    &:hover td { background-color: ${({ theme }) => theme.color.primary_50}; }
    &:last-child td { border-bottom: 0; }
`;
export const NoData = styled.div`
    padding: 40px 16px; text-align: center; white-space: normal;
    color: ${({ theme }) => theme.color.text_color_300}; font-size: 13px;
`;
export const ActionButton = styled(Button).attrs({ $size: 'sm' })`
    background: transparent; border-color: transparent;
    color: ${({ theme, $variant }) => $variant === 'danger' ? theme.color.point_n_100 : theme.color.text_color_200};
    &:hover:not(:disabled) { background: ${({ theme }) => theme.color.primary_50}; border-color: ${({ theme }) => theme.color.primary_300}; }
`;
export const Badge = styled.span<{ $color?: string; $tone?: StatusTone }>`
    display: inline-flex; align-items: center; gap: 4px; flex-shrink: 0;
    height: 22px; padding: 0 7px; border-radius: 4px; font-size: 12px; font-weight: 500; line-height: 1; white-space: nowrap;
    color: ${({ theme, $tone = 'neutral', $color }) => $color || statusColors[theme.name][$tone]};
    background: ${({ theme, $tone = 'neutral', $color }) => ($color || statusColors[theme.name][$tone]) + '18'};
    svg { width: 13px; height: 13px; flex-shrink: 0; }
`;
export const TableFooter = styled.div`
    position: relative; display: flex; align-items: center; justify-content: center;
    gap: 16px; min-height: 44px; flex-wrap: wrap;
    & > div:first-child:not(nav) { position: absolute; left: 0; }
`;
